/**
 * Dashboard Helper — SLIM (D2 rebuild, 2026-07-17).
 *
 * The old version downloaded 10 collections (full-FY transactions,
 * subTransactions, stockFlow + all masters) on every dashboard load and
 * computed 8 analytics widget datasets in the browser — the single biggest
 * read source in the fleet (74% of the top company's reads).
 *
 * D2 removed those widgets (owner decision). Widget data now comes from
 * src/utils/dashboardWidgetData.js — small range-bounded fetches and
 * server-side aggregations, each cached for DASHBOARD_TTL_MS. The old
 * compute code was deleted with the widgets it fed.
 *
 * This module keeps:
 *  - DASHBOARD_TTL_MS: the dashboard-wide cache TTL (KPI cards + widgets)
 *  - fetchDashboardData: context-level payload (currently just an empty
 *    notifications list — ZERO Firestore reads)
 */

// Dashboard-specific cache TTL (D1): 2 hours. The dashboard is the landing
// screen; KPIs may lag up to 2h — the Refresh button always fetches live.
export const DASHBOARD_TTL_MS = 2 * 60 * 60 * 1000;

export const fetchDashboardData = async (companyId) => {
  if (!companyId) return null;
  // Notifications were derived from the old full-year download. Dropped in D2
  // (owner-approved). If cheap aggregation-based alerts are wanted later,
  // build them in dashboardWidgetData.js.
  return { notifications: [] };
};

export default fetchDashboardData;
